import { useTranslation } from 'react-i18next';

import { Tag } from '@adflow/frontend/ui-common';
import {
	SelectorSelectWithControl,
	selectorStyles,
} from '@adflow/frontend/ui-form';
import { REQUIRED_MARK, theme } from '@adflow/frontend/ui-theme';

function getColor(status: string) {
	switch (status) {
		case 'ACTIVE': {
			return theme.colors.statuses.ACTIVE;
		}
		case 'ENABLED': {
			return theme.colors.statuses.ENABLED;
		}
		case 'PAUSED': {
			return theme.colors.statuses.PAUSED;
		}
		case 'REMOVED': {
			return theme.colors.statuses.REMOVED;
		}
		case 'ARCHIVED': {
			return theme.colors.statuses.ARCHIVED;
		}
		case 'DELETED': {
			return theme.colors.statuses.DELETED;
		}
		case 'UNKNOWN': {
			return theme.colors.statuses.UNKNOWN;
		}
		case 'UNSPECIFIED': {
			return theme.colors.statuses.UNSPECIFIED;
		}
		default: {
			return '#FFFFFF';
		}
	}
}

interface SelectorStatusProps {
	name: string;
	items?: string[];
	isLoading?: boolean;
}

export function SelectorStatus({
	name,
	items,
	isLoading,
}: SelectorStatusProps) {
	const { t } = useTranslation('facebook');

	return (
		<SelectorSelectWithControl
			name={name}
			label={t('status') + REQUIRED_MARK}
			placeholder={t('status')}
			outerStyle={{ gridColumn: 'span 2 / span 2' }}
			items={items ?? []}
			renderOption={(value, getRootProps, highlighted) => (
				<li
					{...getRootProps?.()}
					data-highlighted={highlighted || undefined}
					// `data-value` is only used by tests.
					data-value={value}
					css={selectorStyles.listItem}
				>
					<Tag
						size="clickable"
						text={value ?? ''}
						color={getColor(value) ?? '#FFFFFF'}
						css={{ width: '100%' }}
					/>
				</li>
			)}
			isLoading={isLoading}
		/>
	);
}
